import { ApplicationConfig, CSP_NONCE, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader, provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';

const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') ?? '';

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: CSP_NONCE,
            useValue: nonce,
        },
        provideZonelessChangeDetection(),
        provideRouter(
            routes,
            withComponentInputBinding(),
            withViewTransitions()
        ),
        provideAnimationsAsync(),
        provideNativeDateAdapter(),
        provideHttpClient(
            withInterceptorsFromDi()
        ),
        TranslateModule.forRoot({
            fallbackLang: 'en',
            loader: {
                provide: TranslateLoader,
                useClass: TranslateHttpLoader
            }
        }).providers!,
        provideTranslateHttpLoader()
    ]
};
